import axios from 'axios';

const saveShowingDefaultSettings = async (showingSettings: todo) => {
  const { data } = await axios.post(
    '/user_appointment_config',
    showingSettings,
  );
  return data;
};

export default saveShowingDefaultSettings;
